import styled from 'styled-components';

import { getMeasureProp } from '../../styles';


type RootProps = {
	padding: number | string;
}

const Root = styled.div<RootProps>`
	width: 100%;
	height: auto;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	padding: 35px 0;

	${p => p.padding && `
		padding: ${getMeasureProp(p.padding)};
	`}
`;

const ContentLayout = styled.div`
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
`;

const IconLayout = styled.div`
	margin-bottom: 30px;
`;

export {
	Root,
	ContentLayout,
	IconLayout,
}